import styled from 'styled-components'

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const PaginationContainer = styled.div`
  border-top: ${props => props.theme.stroke.default} solid #d2d2d2;
  padding-top: ${props => props.theme.spacing.sp24};
  display: flex;
  justify-content: space-between;
`
